import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Alert from '../../components/common/Alert';
import './PasswordSettings.css';

const PasswordSettings = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // State for managing alerts
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  // Password validation function
  const validatePassword = (password) => {
    return (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    );
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }
    if (!validatePassword(newPassword)) {
      setError(
        'Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.'
      );
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New password and confirm password must match.');
      return;
    }

    try {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      if (!userId || !token) {
        setError('User not authenticated. Please log in again.');
        return;
      }

      const response = await fetch(
        `https://api.opencurtainscasting.com/user/changePassword/${userId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            oldPassword: oldPassword,
            newPassword: newPassword,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setAlertMessage('Password changed successfully!');
        setAlertSeverity('success');
        setOpenSnackbar(true);
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setError('Failed to change password. Please try again.');
      }
    } catch (error) {
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className='settings-content'>
      <form className='password-form' onSubmit={handleChangePassword}>
        <div className='form-group'>
          <h2>Change Password</h2>
          <label>Old Password</label>
          <div className='password-input-wrapper'>
            <input
              type={showOldPassword ? 'text' : 'password'}
              placeholder='Enter old password'
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowOldPassword(!showOldPassword)}>
              <FontAwesomeIcon icon={showOldPassword ? faEyeSlash : faEye} />
            </span>
          </div>
        </div>
        <div className='form-group'>
          <label>New Password</label>
          <div className='password-input-wrapper'>
            <input
              type={showNewPassword ? 'text' : 'password'}
              placeholder='Enter new password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowNewPassword(!showNewPassword)}>
              <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
            </span>
          </div>
          <small>
            {newPassword.length >= 8 ? '✓' : '✗'} At least 8 characters<br />
            {/[A-Z]/.test(newPassword) ? '✓' : '✗'} At least 1 uppercase letter<br />
            {/[a-z]/.test(newPassword) ? '✓' : '✗'} At least 1 lowercase letter<br />
            {/\d/.test(newPassword) ? '✓' : '✗'} At least 1 number<br />
            {/[^A-Za-z0-9]/.test(newPassword) ? '✓' : '✗'} At least 1 special character
          </small>
        </div>
        <div className='form-group'>
          <label>Confirm Password</label>
          <div className='password-input-wrapper'>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder='Confirm new password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              <FontAwesomeIcon
                icon={showConfirmPassword ? faEyeSlash : faEye}
              />
            </span>
          </div>
        </div>
        {error && <p className='error-message'>{error}</p>}
        {success && <p className='success-message'>{success}</p>}
        <button type='submit' className='passwordSettingBtn'>
          Save Changes
        </button>
      </form>
      <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />
    </div>
  );
};

export default PasswordSettings;
